import { CSSProperties } from "react";

/**
 * Sets the display property of the accessibility button.
 * @param display - The value for the CSS `display` property.
 */
const setAccessabilityButtonDisplay = (display: CSSProperties["display"]) => {
  const style = document.createElement("style");
  style.innerHTML = `
      body {
        .uwy {
          display: ${display};
        }
      }
    `;
  document.head.appendChild(style);
};

export default setAccessabilityButtonDisplay;
